import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { Financialassetsmodel } from './model/financialassetsmodel';

@Injectable({
  providedIn: 'root'
})
export class FinancialassetsService {
 // FinancialassetsUrl = 'https://localhost:44306/api/' + 'FinancialAssets/';
  FinancialassetsUrl = this.ConfigService.getAPIBaseUrl() + 'api/FinancialAssets/';
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  insertFinancialAssetsGrid(data) {
    debugger
    return this.http.post(this.FinancialassetsUrl + 'InsertFinancialAssets', data);
  }

  getFinancialassets(apPeriodId) {
    return this.http.get(this.FinancialassetsUrl + 'GetFinancialassets?apPeriodId=' + apPeriodId);
  }
  getFinancialassets_LY(apPeriodId) {
    return this.http.get(this.FinancialassetsUrl + 'GetFinancialassets_LY?apPeriodId=' + apPeriodId);
  }
}
